/* eslint-disable import/prefer-default-export */
import qs from "qs";
import { authorizedApiClient } from "./config";
import type { AssociatedObjectsResponse, EmailsResponse, MeetingsResponse } from "../shared/emails-meetings/types";

// Account Associated Objects
type GetAccountAssociatedObjects = {
    workspace_id: string;
    account_external_id: string;
    object_types?: string[];
    limit?: number;
    offset?: number;
};

export const getAccountAssociatedObjects = async ({
    workspace_id,
    account_external_id,
    object_types,
    limit = 50,
    offset = 0,
}: GetAccountAssociatedObjects) =>
    authorizedApiClient.get<AssociatedObjectsResponse>(
        `/${workspace_id}/accounts/${account_external_id}/associated-objects`,
        {
            params: {
                object_types,
                limit,
                offset,
            },
            paramsSerializer(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            },
        }
    );

type GetAccountEmails = {
    workspace_id: string;
    account_external_id: string;
    limit?: number;
    offset?: number;
    sort_by?: string;
    order_by?: string;
    q?: string;
};

export const getAccountEmails = async ({
    workspace_id,
    account_external_id,
    limit = 20,
    offset = 0,
    sort_by,
    order_by,
    q,
}: GetAccountEmails) =>
    authorizedApiClient.get<EmailsResponse>(
        `/${workspace_id}/accounts/${account_external_id}/emails`,
        {
            params: {
                limit,
                offset,
                sort_by,
                order_by,
                q,
            },
        }
    );

type GetAccountMeetings = {
    workspace_id: string;
    account_external_id: string;
    limit?: number;
    offset?: number;
};

export const getAccountMeetings = async ({
    workspace_id,
    account_external_id,
    limit = 50,
    offset = 0,
}: GetAccountMeetings) =>
    authorizedApiClient.get<MeetingsResponse>(
        `/${workspace_id}/accounts/${account_external_id}/meetings`,
        {
            params: {
                limit,
                offset,
            },
        }
    );

// Contact Associated Objects
type GetContactAssociatedObjects = {
    workspace_id: string;
    contact_external_id: string;
    object_types?: string[];
    limit?: number;
    offset?: number;
};

export const getContactAssociatedObjects = async ({
    workspace_id,
    contact_external_id,
    object_types,
    limit = 50,
    offset = 0,
}: GetContactAssociatedObjects) =>
    authorizedApiClient.get<AssociatedObjectsResponse>(
        `/${workspace_id}/contacts/${contact_external_id}/associated-objects`,
        {
            params: {
                object_types,
                limit,
                offset,
            },
            paramsSerializer(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            },
        }
    );

type GetContactEmails = {
    workspace_id: string;
    contact_external_id: string;
    limit?: number;
    offset?: number;
    sort_by?: string;
    order_by?: string;
    q?: string;
};

export const getContactEmails = async ({
    workspace_id,
    contact_external_id,
    limit = 50,
    offset = 0,
    sort_by,
    order_by,
    q,
}: GetContactEmails) =>
    authorizedApiClient.get<EmailsResponse>(
        `/${workspace_id}/contacts/${contact_external_id}/emails`,
        {
            params: {
                limit,
                offset,
                sort_by,
                order_by,
                q,
            },
        }
    );

type GetContactMeetings = {
    workspace_id: string;
    contact_external_id: string;
    limit?: number;
    offset?: number;
};

export const getContactMeetings = async ({
    workspace_id,
    contact_external_id,
    limit = 50,
    offset = 0,
}: GetContactMeetings) =>
    authorizedApiClient.get<MeetingsResponse>(
        `/${workspace_id}/contacts/${contact_external_id}/meetings`,
        {
            params: {
                limit,
                offset,
            },
        }
    );
